import { render } from "./custardsTable.vue?vue&type=template&id=9cecf952&scoped=true"
import script from "./custardsTable.vue?vue&type=script&lang=js"
export * from "./custardsTable.vue?vue&type=script&lang=js"

import "./custardsTable.vue?vue&type=style&index=0&id=9cecf952&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cecf952"]])

export default __exports__